import { Icon } from '@iconify/react';
import { FC } from 'react'
import { useTranslation } from 'react-i18next';
import "./style.css"

interface ISubmitBtn {
    onSubmit: Function,
    loading?: boolean,
    label: string,
    className?: string,
    disabled?: boolean
}

const SubmitBtn: FC<ISubmitBtn> = ({ onSubmit, loading = false, label, className = "", disabled = false }) => {

    const { t } = useTranslation();


    return (

        <button
            className={`login-content-login-btn pointer submit-btn-component  ${className}`}
            onClick={() => onSubmit()}
            disabled={loading || disabled}
        >    {loading ?
            <Icon icon="eos-icons:three-dots-loading" width={30} />
            : <span>{t(`${label}`)} </span>
            }
        </button>
    )
}

export default SubmitBtn